import { sleep } from '@enuygun/frontend-components'
import dayjs from 'dayjs'

interface WingieCarRentalLocation {
  slug?: string
}

export interface WingieCarRentalFormValues {
  pickUpLocation?: WingieCarRentalLocation
  dropOffLocation?: WingieCarRentalLocation
  hasDropOffLocation?: boolean
  pickUpDate?: string
  dropOffDate?: string
  pickUpTime?: string
  dropOffTime?: string
  driverAge?: string
  countryOfResidence?: string
}

const DATE_FORMAT = 'YYYY-MM-DD'

/** residenceCountry search sayfasındaki ikamet ülkesi seçicisini doldurur; formda seçim yoksa market değeri kullanılır. */
export const buildWingieCarRentalSearchPath = (form: WingieCarRentalFormValues, currency?: string, residenceCountry?: string) => {
  const pickUpLocation = form?.pickUpLocation?.slug || ''
  const dropOffLocation = (form?.hasDropOffLocation ? form?.dropOffLocation?.slug : pickUpLocation) || pickUpLocation

  const params = new URLSearchParams()
  params.set('pickUpDate', dayjs(form?.pickUpDate).format(DATE_FORMAT))
  if (form?.pickUpTime) params.set('pickUpTime', form.pickUpTime)
  params.set('dropOffDate', dayjs(form?.dropOffDate).format(DATE_FORMAT))
  if (form?.dropOffTime) params.set('dropOffTime', form.dropOffTime)
  params.set('pickUpLocation', pickUpLocation)
  params.set('dropOffLocation', dropOffLocation)
  if (form?.driverAge) params.set('driverAge', form.driverAge)
  if (currency) params.set('currency', currency)

  const selectedResidenceCountry = form?.countryOfResidence || residenceCountry
  if (selectedResidenceCountry) params.set('residenceCountry', selectedResidenceCountry.toLowerCase())

  return `/cars/search-result/?${params}`
}

export const wingieCarRentalHandleSubmit = async (form: WingieCarRentalFormValues, endpoint = '', delay = 0, currency?: string, residenceCountry?: string) => {
  const redirectPath = buildWingieCarRentalSearchPath(form, currency, residenceCountry)

  await sleep(delay)
  globalThis.location.href = `${endpoint}${redirectPath}`
}
